import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Home() {
  const { user, adminExists } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (adminExists === null || user === null) return;
    if (!adminExists) navigate("/primeiro-acesso", { replace: true });
    else if (user) navigate("/painel", { replace: true });
    else navigate("/login", { replace: true });
  }, [user, adminExists, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
      <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
    </div>
  );
}
